module.exports = __webpack_public_path__ + "static/media/foto4.056a7105.png";